import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Pagination, Regulation } from '../models';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class RegulationService extends BaseApiService<Regulation> {
  get cacheKey(): StorageKey {
    return StorageKey.regulationServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    switch (operation) {
      case 'list':
        let regionId = params.regionId;
        if (regionId == null) {
          regionId = '1';
        }
        return `${environment.apiUrl}/regions/${encodeURIComponent(regionId)}/regulations`;
      default:
        let url = `${environment.apiUrl}/regulations`;
        if (id != null) {
          url = url + '/' + encodeURIComponent(id);
        }
        return url;
    }
  }

  list(params: {[params: string]: string}): Promise<Pagination<Regulation>> {
    return super.list(this.removeContractId(params));
  }

  protected unparse(obj) {
    return Regulation.unparse(obj);
  }

  protected parse(obj) {
    return Regulation.parse(obj);
  }

}
